import React from "react";
import { Modal, Button } from "react-bootstrap";

interface ConfirmDeleteModalProps {
  show: boolean;
  title?: string; // e.g. "Delete Course"
  message?: string; // e.g. "Are you sure you want to delete this course?"
  iconClassName?: string; // e.g. "isax isax-trash"
  onClose: () => void;
  onConfirm: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  show,
  title = "Delete Item",
  message = "Are you sure you want to delete this item?",
  iconClassName = "isax isax-trash",
  onClose,
  onConfirm,
  confirmButtonText = "Yes, Delete",
  cancelButtonText = "Cancel",
}) => {
  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Body className="text-center custom-modal-body">
        <span className="avatar avatar-lg bg-danger-transparent rounded-circle mb-2 d-inline-flex justify-content-center align-items-center">
          <i className={`${iconClassName} fs-24 text-danger`} />
        </span>
        <div>
          <h4 className="mb-2">{title}</h4>
          <p className="mb-3">{message}</p>
          <div className="d-flex align-items-center justify-content-center">
            <Button
              variant="light"
              className="rounded-pill me-2"
              onClick={onClose}
            >
              {cancelButtonText}
            </Button>
            <Button
              variant="secondary"
              className="rounded-pill"
              onClick={onConfirm}
            >
              {confirmButtonText}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmDeleteModal;
